<template>
  <div class="q_pad_lr15px q_mar_t15px">
<!--    <div class="q_po_re">-->
<!--      <van-image class="q_speed_bg" fit="cover" :src="require('../../assets/image/cert_speed.jpg')"/>-->
<!--      <div class="q_po_ab" style="top: 46vw;left: 0;padding: 0 13vw;">-->
<!--        <div class="q_center">证书编号 <span class="q_text_m q_bold">{{ certificate.certificateNo }}</span></div>-->
<!--        <div class="q_mar_t30px">-->
<!--          <span class="q_pad_lr15px q_bor_bottom q_bold" style="border-color: #333333;">{{certificate.userName}}</span>-->
<!--          {{certificate.userSex == '0' ? '先生' : certificate.userSex == '1' ? '女士' : '未知'}}-->
<!--        </div>-->
<!--        <div class="q_mar_t15px q_justify">感谢您向【-->
<!--          <span class="q_bold">{{ certificate.projectName }}</span>】项目捐助-->
<!--&lt;!&ndash;          <span class="q_bold">{{ certificate.money }}元</span>&ndash;&gt;-->
<!--          。大爱无疆，感谢您让世界更美好。-->
<!--        </div>-->
<!--        <div class="q_mar_t20px">特颁此证！</div>-->
<!--        <div class="q_mar_t20px q_right">-->
<!--          <div>{{ certificate.dept_name }}</div>-->
<!--          <div>{{-->
<!--              parseTime(certificate.create_time)-->
<!--            }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="q_po_re">
      <van-image class="q_speed_bg" fit="cover" :src="url" />
    </div>

    <div v-if="isShow" style="width:512px;height:910px;margin-left:auto;margin-right:auto;" class="zsbox" id="downdata"
         ref="exportPdf"
    >
      <div id="zs"
           :style="donationStyle"
      >
        <div class="p1"
             style="top: 380px;font-size: 28px;position: absolute;color: black;width: 80%;left: 10%;text-align: center;"
        >
          {{ certificate.userName }}
        </div>
        <div class="p1" :title=" certificate.projectName "
             style="text-align: center;left: 250px;top: 467px;font-size: 20px;position: absolute;width: 210px;color: black;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;"
        >
          {{ certificate.projectName }}
        </div>
        <div class="p1"
             style="right: 65px;bottom: 120px;font-size: 14px;font-weight: 700;position: absolute;color: #000000;"
        >
          {{ parseTime(certificate.grantTime, '{y}年{m}月{d}日') }}
        </div>

      </div>
    </div>

<!--    <div class="q_vertical_left q_mar_t15px" style="width: 100%" @click="goToSpeeddea(donation.id)">-->
<!--      <div class="q_inlineblock">-->
<!--        <van-image class="q_speed_img" fit="cover" :src="donation.pic"/>-->
<!--      </div>-->
<!--      <div class="q_mar_l15px q_inlineblock" style="width: 100%;">-->
<!--        <div class="q_text_m q_bold q_moit2 q_justify">{{ donation.ittle }}</div>-->
<!--        <div class="q_mar_t20px">-->
<!--          <div class="q_speed q_inlineblock q_veralign_middle" style="width: 60%;">-->
<!--            <span class="q_text_s q_color_gray">{{ donation.percentage }}%</span>-->
<!--            <span class="q_text_s q_color_gray q_flo_right">{{ donation.sumMoney }}元</span>-->
<!--            <div class="q_speed_b">-->
<!--              <div :style="{width: donation.percentage + '%'}" class="q_speed_t"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; 日期年月日即可，不用到时分秒。搁不哈 &ndash;&gt;-->
<!--          <div class="q_text_s q_color_gray q_inlineblock q_veralign_middle q_right" style="width: 40%;">-->
<!--            {{ donation.createTime }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {certificateById, } from "@/api/certificate";
import {parseTime, wxCloseShare} from "@/utils/jiutang";
import zsbj2 from '@/assets/image/zsbj2.png'
import html2canvas from "html2canvas";

export default {
  name: 'Forspeed',
  props: {
    msg: String
  },
  data() {
    return {
      certificateId: '',
      certificate: {},
      donation: {},
      donationStyle: 'position:relative;width:512px;height:910px;background:url(' + zsbj2 + ');background-size:512px 910px;margin-left:auto;margin-right:auto;',
      isShow:true,
      url :''
    }
  },
  created() {
    this.certificateId = this.$route.query.id;
    this.init()
  },
  methods: {
    /**
     * 页面初始化
     */
    init() {
      wxCloseShare()
      this.$modal.loading()
      //获取证书表信息
      certificateById(this.certificateId).then((res) => {
        this.certificate = res.data
      }).finally(() => {
        this.pdf()
        this.$modal.closeLoading()
      })
      //     .then(() => {
      //   //获取协会信息
      //   var param = {
      //     id: this.certificate.activity_id
      //   }
      //   console.log('param',param)
      //   listDonation(param).then(res => {
      //     console.log('resss',res)
      //     this.donation = res.rows[0]
      //     this.donation.createTime = res.rows[0].createTime.substring(0, 10)
      //     this.donation.percentage = ((res.rows[0].money / res.rows[0].sumMoney) * 100).toFixed(2)
      //   })
      // })
    },
    goToSpeeddea(id) {
      this.$router.push({
        path: '/home/Speeddea', query: {id: id}
      });
    },
    parseTime(time) {
      return parseTime(time, '{y}-{m}-{d}')
    },
    pdf(){
      html2canvas(this.$refs.exportPdf, {
        backgroundColor: '#ffffff',
        useCORS: true,
        // width: window.screen.availWidth,
        // height: window.screen.availHeight,
        windowHeight: document.body.scrollHeight,
        y: window.pageYOffset
      }).then((canvas) => {
        this.url = canvas.toDataURL()
        this.isShow = false
      })
    }
  },
}
</script>
<style scoped="scoped">
.q_speed_img {
  width: 110px;
  height: 110px;
}

.q_speed_img >>> .van-image__img {
  border-radius: 5px;
}

.q_speed_b {
  background-color: #F2F3F7;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  position: relative;
}

.q_speed_t {
  background-color: #FF5733;
  width: 10%;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 0px;
  left: 0;
}

.q_speed_bg {
  width: 100%;
}
</style>
